import EntityType from '@/shared/enums/EntityType';
import EntityLabel from './EntityLabel';
import PropertyLabel from './PropertyLabel';
import SkillLabel from './SkillLabel';
import TagLabel from './TagLabel';
import getTooltipEntityType from './utils/getTooltipEntityType';

const TooltipLabel = ({ item }) => {
  const entityType = getTooltipEntityType(item);

  switch (entityType) {
    case EntityType.TAG:
      return <TagLabel item={item} />;
    case EntityType.SKILL:
      return <SkillLabel item={item} />;
    case EntityType.PROPERTY:
      return <PropertyLabel item={item} />;
    default:
      return <EntityLabel item={item} />;
  }
};

export default TooltipLabel;
